import type { EditorFeatureAttrs } from "../editorTypes";
import StatusBadge from "./StatusBadge";
import FeatureForm from "./FeatureForm";

interface AttributePanelProps {
  attrs: EditorFeatureAttrs | null;
  onSaveProps: (propriedades: Record<string, unknown>) => void;
}

export default function AttributePanel({ attrs, onSaveProps }: AttributePanelProps) {
  if (!attrs) {
    return (
      <div className="p-4 text-center text-xs text-foreground-400">
        <i className="ri-cursor-line text-2xl mb-2 block" />
        Selecione ou desenhe uma feição para ver os atributos.
      </div>
    );
  }

  return (
    <div className="p-3 space-y-3">
      <div className="flex items-center justify-between">
        <p className="text-[11px] font-semibold text-foreground-500 uppercase tracking-wide">Atributos</p>
        <StatusBadge status={attrs.status} />
      </div>

      <div className="grid grid-cols-2 gap-2 text-[11px] bg-background-50 rounded-md p-2.5">
        <div>
          <span className="text-foreground-400 block">Tipo de objeto</span>
          <span className="text-foreground-800 font-medium">{attrs.tipoObjeto || "—"}</span>
        </div>
        <div>
          <span className="text-foreground-400 block">Camada destino</span>
          <span className="text-foreground-800 font-medium truncate block">{attrs.camadaDestino || "—"}</span>
        </div>
        <div>
          <span className="text-foreground-400 block">Geometria</span>
          <span className="text-foreground-800 font-medium">{attrs.tipoGeometria || "—"}</span>
        </div>
        <div>
          <span className="text-foreground-400 block">Fonte</span>
          <span className="text-foreground-800 font-medium">EDITOR_TERRITORIAL_WEBGIS</span>
        </div>
        <div className="col-span-2">
          <span className="text-foreground-400 block">Validação</span>
          <span className="text-foreground-800 font-medium">ESTIMATIVA_VISUAL_PRELIMINAR</span>
        </div>
        {!attrs.rascunhoId && (
          <div className="col-span-2 text-caution-700 bg-caution-50 rounded px-2 py-1">
            Feição ainda não salva — use "Salvar rascunho" na barra de ferramentas.
          </div>
        )}
      </div>

      <FeatureForm attrs={attrs} onSave={onSaveProps} />
    </div>
  );
}
